var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pa-2 pa-md-0"},_vm._l((_vm.mesasMostrar),function(mesa){return _c('v-col',{key:mesa.id,staticClass:"pa-2 pa-md-3",attrs:{"cols":"6","sm":"4","md":"3"}},[_c('mesa-card',{attrs:{"mesa":mesa}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }